<div class="main-container">
  <div class="detail-container">
    <div class="title">
      <label>{{ "claimOffice.underwritingComments.underwriterNotes" | translate }}</label>
    </div>
    <hr />
    <div class="note-info">
      <label class="note-label">
        {{ "claimOffice.underwritingComments.suicideExclusion" | translate }}
      </label>
      <p class="note-detail">
        {{ "claimOffice.underwritingComments.suicideExclusionInfo" | translate }}
      </p>
    </div>
    <hr class="hr-97-mr-0" />
    <div class="note-info">
      <label class="note-label">
        {{ "claimOffice.underwritingComments.misstatementOfAgeClause" | translate }}
      </label>
      <p class="note-detail">
        {{ "claimOffice.underwritingComments.misstatementOfAgeClauseInfo" | translate }}
      </p>
    </div>
    <div class="underwiter-comments">
      <label class="label">
        {{ "claimOffice.underwritingComments.underwriterComments" | translate }}
      </label>
      <p class="comments-content">
        {{underwriterComments}}
      </p>
    </div>
  </div>
</div>